import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from './../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const ClientAccountWebAccountsCreate = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { account_id } = useParams();
    
    useEffect(() => {
        getOne(`/admin/clients/clients/${account_id}/webaccounts/`, 'new').then(response => {
            setMetadata(response.data.metadata);
            setData({
                timezone: response.data.metadata?.timezones?.default,
            });
        }).catch(error => {
            toast.error("Error fetching web account: " + error.message, {});
        });
    }, [account_id]);

    const handleSave = () => {
        create(`/admin/clients/clients/${account_id}/webaccounts/`, {data: data}).then(() => {
            navigate(`/clients/clients/${account_id}/webaccounts`);
        }).catch(error => {
            toast.error("Error creating web account: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/clients/clients/${account_id}/webaccounts`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageTextField label="Email" id="email" onChange={ onChange } value={ data.email } />
                    <EditPageTextField label="Password" type="password" id="password" onChange={ onChange } value={ data.password } />
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Phone" id="phone" onChange={ onChange } value={ data.phone } />
                    <EditPageSelect label="Timezone" id="timezone" onChange={ onChange } value={ data.timezone } options={ metadata?.timezones?.values } />
                    <EditPageCheckbox label="Enabled" id="enabled" onChange={ onChange } value={ data.enabled } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default ClientAccountWebAccountsCreate;